import { useDeviceCountsQuery } from "generated/graphql";
import { constructFilterList } from "utilities/filters/deviceFilters";
import { GenericBucket, isArrayOfGenericBucket } from "routes/Home/bucketTypes";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";
import { useContext } from "react";

export const useDeviceCount = () => {
  const { tenant } = useContext(SelectedTenantContext);
  const tenantId = tenant?.id ?? "";

  const { data, fetching } = useDeviceCountsQuery({
    variables: {
      filter: {
        AND: constructFilterList({}, tenantId)
      },
      aggregations: [
        {
          term: "hardwareFamily"
        }
      ]
    }
  });

  let totalCount = 0;
  if (
    data?.deviceAggregations?.[0]?.buckets &&
    isArrayOfGenericBucket(data.deviceAggregations[0].buckets)
  ) {
    const devices = data.deviceAggregations[0].buckets as Array<GenericBucket>;
    totalCount = devices.reduce((count, device) => count + device.count, 0);
  }

  return {
    count: totalCount,
    fetching
  };
};
